export default __webpack_public_path__ + "static/media/guest.bb1b8a95.svg";